"use client";

import { createContext, type ReactNode, useContext } from "react";
import type { TenantBranding, TenantConfig } from "./types";

const TenantContext = createContext<TenantConfig | null>(null);

interface TenantProviderProps {
	tenant: TenantConfig;
	children: ReactNode;
}

export function TenantProvider({ tenant, children }: TenantProviderProps) {
	return (
		<TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
	);
}

export function useTenant(): TenantConfig {
	const ctx = useContext(TenantContext);
	if (!ctx) {
		throw new Error("useTenant must be used within a TenantProvider");
	}
	return ctx;
}

export function useTenantBranding(): TenantBranding {
	return useTenant().branding;
}

/** Returns `true` if the named feature is enabled (i.e. not `false`). */
export function useFeature(feature: string): boolean {
	return useTenant().features[feature] === true;
}
